import React, { useState } from "react";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import { Link } from "react-router-dom";
import Header from "./Header";
import img2 from "../assets/images/landing-page/section-1-artwork-sample.png";
import drop1 from "../assets/images/landing-page/latest-drops-1.png";
import drop2 from "../assets/images/landing-page/latest-drops-2.png";
import fArtist1 from "../assets/images/landing-page/featured-artist-artwork-1.png";
import fArtist2 from "../assets/images/landing-page/featured-artist-artwork-2.png";
import emailIcon from "../assets/images/landing-page/email-input-field-button.svg";
import popular1 from "../assets/images/landing-page/most-popular-artwork-1.png";
import popular2 from "../assets/images/landing-page/most-popular-artwork-2.png";
import popular3 from "../assets/images/landing-page/most-popular-artwork-3.png";
import popular4 from "../assets/images/landing-page/most-popular-artwork-4.png";
import popular5 from "../assets/images/landing-page/most-popular-artwork-5.png";
import activity1 from "../assets/images/landing-page/recent-activity-artwork-1.png";
import activity2 from "../assets/images/landing-page/recent-activity-artwork-2.png";
import activity3 from "../assets/images/landing-page/recent-activity-artwork-3.png";
import activity4 from "../assets/images/landing-page/recent-activity-artwork-4.png";
import activity5 from "../assets/images/landing-page/recent-activity-artwork-5.png";
import Footer from "./Footer";

const Home = () => {
  const [address, setAddress] = useState("");
  const [collectionId, setCollectionId] = useState("");

  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <Header />
      {/* Header area end */}

      {/* Hero slider start */}
      <div className="container-fluid">
        <Link to="/Collection">
          <div className="row header justify-content-center">
            <div className="header-text col-lg-7 col-sm-12"></div>
            <div className="col-lg-4 col-sm-10 artist text-center">
              <span>Artist Name</span>
              <h6>Collection Title</h6>
              <h1>March 19</h1>
              <p>1:30 PM EST Drawings</p>
              <p>2:30 PM EST Open Editions</p>
            </div>
          </div>
        </Link>
      </div>
      {/* Hero slider end */}

      {/* Section 1 area start */}
      <div className="container margin-70">
        <div className="row section-1 justify-content-center">
          <div className="col-lg-6 col-sm-12 col-md-12 section-content">
            <h1>
              LOREM IPSUM DOLOR SIT AMET, CONSECTETUER ADIPI- SCING ELIT, SED
              DIAM
            </h1>
            <h1>LOREM IPSUM</h1>
            <button type="button">
              <Link to="/Marketplace">Explore Marketplace</Link>
            </button>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5 section-img text-center">
            <img src={img2} alt="section1" />
          </div>
        </div>
      </div>
      {/* Section 1 area end */}

      {/* Latest Drop area start */}
      <div className="container margin-70">
        <div className="row text-center">
          <div className="col-md-12">
            <h2 className="heading">Mint collection!</h2>

            <input
              value={address}
              style={{ height: "40px", fontSize: "12px" }}
              placeholder="Collection id"
              onChange={(e) => setAddress(e.target.value)}
              onPaste={(e) => setAddress(e.target.value)}
              type="text"
            />
            <Link to={`/mintcollection/${address}`}>
              {" "}
              <button className="buy-button">Go to mint page</button>
            </Link>
            <br />
            <br />
            <h2 className="heading">See collection!</h2>

            <input
              value={collectionId}
              style={{ height: "40px", fontSize: "12px" }}
              placeholder="Collection id"
              onChange={(e) => setCollectionId(e.target.value)}
              onPaste={(e) => setCollectionId(e.target.value)}
              type="text"
            />
            <Link to={`/collection/${collectionId}`}>
              <button className="buy-button">Go to collection page</button>
            </Link>
            <br />
            <br />
            <h2 className="heading">Latest Drops!</h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-5 mb-2">
            <Link to="/Collection/0xBDaF82febb1CC0fa6DbFF0Ac4100CAF9C87f1564">
              <img className="full-width" src={drop1} alt="" />
            </Link>
          </div>
          <div className="col-md-5">
            <Link to="/Collection/0xFe9367181A8b91e6e42d392F9aa6a1f60A41BD2c">
              <img className="full-width" src={drop2} alt="" />
            </Link>
          </div>
        </div>
      </div>
      {/* Latest Drop area end */}

      {/* Featured Artist area start */}
      <div className="container margin-70">
        <div className="row">
          <h1 className="heading heading-padding">Featured Artists</h1>
        </div>
        <div className="row">
          <div className="artist-card mb-2">
            <div className="content">
              <Link to="/UserProfileArtist">
                <div className="content-overlay"></div>
                <img className="content-image" src={fArtist2} alt="" />
                <div className="content-details fadeIn-bottom text-left">
                  <h3 className="content-title">Odesza</h3>
                  <p className="content-text">
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy nibh euis
                  </p>
                </div>
              </Link>
            </div>
          </div>
          <div className="artist-card mb-2">
            <div className="content">
              <Link to="/UserProfileArtist">
                <div className="content-overlay"></div>
                <img className="content-image" src={fArtist1} alt="" />
                <div className="content-details fadeIn-bottom text-left">
                  <h3 className="content-title">Odesza</h3>
                  <p className="content-text">
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy nibh euis
                  </p>
                </div>
              </Link>
            </div>
          </div>
          <div className="artist-card mb2">
            <div className="content">
              <Link to="/UserProfileArtist">
                <div className="content-overlay"></div>
                <img className="content-image" src={fArtist2} alt="" />
                <div className="content-details fadeIn-bottom text-left">
                  <h3 className="content-title">Odesza</h3>
                  <p className="content-text">
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy nibh euis
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Featured Artist area end */}

      {/* Newsletter area start */}
      <div className="container margin-70">
        <div className="newsletter text-center">
          <h1 className="heading">Heading</h1>
          <h2 className="sub-heading">People, Music, Artists, memories.</h2>
          <p>For the latests drops - subscribe </p>
          <div className="input-icons">
            <img src={emailIcon} alt="" />
            <input type="email" placeholder="Email address" required></input>
          </div>
        </div>
      </div>
      {/* Newsletter area end */}

      {/* Most Popular area start */}
      <div className="container margin-70">
        <div className="row">
          <h1 className="heading heading-padding">Most Popular</h1>
        </div>
        <div className="most-popular home row">
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/0">
                <img src={popular1} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/0">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/1">
                <img src={popular2} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/1">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/2">
                <img src={popular3} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/2">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/3">
                <img src={popular4} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/3">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/4">
                <img src={popular5} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem/0x90270b0f5f26EdA5aDcb823Ac4cD2c58517A8E1e/4">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Most Popular area end */}

      {/* Recent activity area start */}
      <div className="container margin-70">
        <div className="row">
          <h1 className="heading heading-padding">Recent Activity</h1>
        </div>
        <div className="most-popular row">
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem">
                <img src={activity1} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem">
                <img src={activity2} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem">
                <img src={activity3} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem">
                <img src={activity4} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="most-popular-card">
              <Link to="/SpecificItem">
                <img src={activity5} className="card-img-top" alt="" />
              </Link>
              <div className="card-body">
                <Link to="/SpecificItem">
                  <h3>Artwork Title</h3>
                </Link>
                <span>
                  <strong>$ 10,000.00</strong>&emsp;
                  <small>13 OF 26</small>
                </span>
                <p className="card-text">
                  <span>
                    <small>HIGHEST BID</small>&emsp;
                    <strong>$8,1234.00</strong>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Recent activity area end */}

      {/* Learn more area start */}
      <div className="container margin-70">
        <div className="newsletter text-center">
          <h1 className="heading">Heading</h1>
          <h2 className="sub-heading">
            Mint your own NFTS, Open your own Collection, Become a Partner
          </h2>
          <p>Signup to learn more.</p>
          <div className="input-icons">
            <img src={emailIcon} alt="" />
            <input
              className="input-field"
              type="email"
              placeholder="Email address"
              required
            />
          </div>
        </div>
      </div>
      {/* Learn more area end */}

      {/* Footer area start */}
      <Footer></Footer>
      {/* Footer area end */}
    </div>
  );
};

export default Home;
